import { useAuth } from 'react-oidc-context';
import {
  DeleteShipmentButtonProps,
  OrderStatusCode,
  ROLE,
} from '../interface/interface';

export function DeleteShipmentButton({
  currentOrderStatus,
  hasDeletedShipment,
  handleModalClick,
  auspostTrackingId,
}: DeleteShipmentButtonProps) {
  const { user } = useAuth();
  const isPLO = [ROLE.PLO].includes((user?.profile.groups as ROLE[])[0]);

  if (!user?.access_token || isPLO) return <></>;

  const allowedOrderStatuses = [
    OrderStatusCode.DISPENSED,
    OrderStatusCode.READY_FOR_SHIPPING,
    OrderStatusCode.PARCEL_RETURNED,
  ].includes(currentOrderStatus!);

  const hasAuspostId = ['', null, undefined].includes(auspostTrackingId);

  if (!allowedOrderStatuses || hasDeletedShipment || hasAuspostId) return <></>;

  return (
    <button
      className="b bg-primary-red-600 text-white p-3 
                2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base font-semibold rounded mr-6"
      onClick={() => handleModalClick()}
    >
      Delete Shipment
    </button>
  );
}
